import { render, staticRenderFns } from "./next_steps_box.vue?vue&type=template&id=01573ad0&scoped=true&"
import script from "./next_steps_box.vue?vue&type=script&lang=js&"
export * from "./next_steps_box.vue?vue&type=script&lang=js&"
import style0 from "./next_steps_box.vue?vue&type=style&index=0&id=01573ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01573ad0",
  null
  
)

export default component.exports